import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

const CarouselBanner = () => {
  const responsive = {
    desktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const slides = [
    {
      title: "Custom Web Development",
      subtitle:
        "Empowering businesses with scalable, secure, and responsive web solutions tailored to your goals.",
      btnText: "Explore Services",
      link: "/web-development",
    },
    {
      title: "Mobile App Solutions",
      subtitle:
        "Transform your business with powerful Android and iOS mobile applications.",
      btnText: "Get a Quote",
      link: "/app-development",
    },
    {
      title: "E-Commerce Solutions",
      subtitle:
        "Build your online store with robust e-commerce solutions, providing a seamless shopping experience for your customers.",
      btnText: "Start Your Store",
      link: "/e-commerce",
    },
    {
      title: "Digital Marketing",
      subtitle:
        "Boost your brand’s online presence with our targeted digital marketing strategies and SEO optimization.",
      btnText: "Get Started",
      link: "/digital-marketing",
    },
    {
      title: "Cloud Solutions",
      subtitle:
        "Leverage the power of the cloud for scalable, reliable, and cost-effective solutions tailored to your business needs.",
      btnText: "Learn More",
      link: "/cloud-solutions",
    },
  ];

  return (
    <div className="relative pt-20">
      <Carousel
        responsive={responsive}
        draggable={false}
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={5000}
        removeArrowOnDeviceType={["tablet", "mobile"]}
        className="z-0"
      >
        {slides.map((slide, idx) => (
          <div
            key={idx}
            className="relative w-full h-[250px] md:h-[450px] flex items-center justify-center bg-gradient-to-r from-black via-gray-900 to-black  text-white text-center px-6"
          >
            <div>
              <h1 className="text-3xl md:text-5xl text-yellow-600 font-semibold mb-5">
                {slide.title}
              </h1>
              <p className="text-sm md:text-lg max-w-2xl mb-6">
                {slide.subtitle}
              </p>
              {/* <a
                href={slide.link}
                className="bg-gray-400 text-yellow-600 hover:bg-gray-300 px-6 py-3 rounded-full text-sm font-semibold transition"
              >
                {slide.btnText}
              </a> */}
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
};

export default CarouselBanner;
